/**
 * Client entry for TanStack Start, overriding the packaged default so Sentry
 * initialises before hydration.
 *
 * `@sentry/nextjs` injected `sentry.client.config` into the `pages/_app` chunk,
 * which Next required before its first render, so an error thrown while
 * hydrating was still reported. `__root` cannot import the config statically —
 * it is in the server graph too, and the config pulls in `posthog-js` — but this
 * file is client-only, so the import below is hoisted and runs before
 * `hydrateRoot`, exactly as it did under Next.
 */
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";

import { recordAcquisitionSource } from "@/tracking/acquisitionSource";
import { startPostHog } from "@/tracking/posthog";
import "../sentry.client.config";

// Before hydration, while the URL is still the one the visitor landed on.
recordAcquisitionSource();
startPostHog();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>
  );
});
